import ajax from '@/utils/ajax.js'

export default {
    async getTicketTypeIdsByGroundIds(groundIds) {
        let response = await ajax.get(`/ticketType/GetTicketTypeIdsByGroundIds?groundIds=${groundIds}`);
        return response.result;
    }
};